<template>
  <component
    :is="'icon-' + name"
    v-if="name"
    :height="height"
    :width="width"
    fill="currentColor"
    class="plc-svgIcon"
  />
</template>

<script>
import { defineAsyncComponent } from 'vue'

export default {
  name: 'GlSvgIcon',
  components: {
    'icon-arrow-narrow': defineAsyncComponent(() =>
      import(
        /* webpackChunkName: "icons" */
        /* webpackMode: "lazy" */
        /* webpackPreload: true */
        '@/assets/img/icons/icon-arrow-narrow.svg?inline'
      )
    ),
    'icon-alert': defineAsyncComponent(() =>
      import(
        /* webpackChunkName: "icons" */
        /* webpackMode: "lazy" */
        /* webpackPreload: true */
        '@/assets/img/icons/icon-alert.svg?inline'
      )
    ),
    'icon-check': defineAsyncComponent(() =>
      import(
        /* webpackChunkName: "icons" */
        /* webpackMode: "lazy" */
        /* webpackPreload: true */
        '@/assets/img/icons/icon-check.svg?inline'
      )
    ),
    'icon-close': defineAsyncComponent(() =>
      import(
        /* webpackChunkName: "icons" */
        /* webpackMode: "lazy" */
        /* webpackPreload: true */
        '@/assets/img/icons/icon-close.svg?inline'
      )
    ),
    'icon-error': defineAsyncComponent(() =>
      import(
        /* webpackChunkName: "icons" */
        /* webpackMode: "lazy" */
        /* webpackPreload: true */
        '@/assets/img/icons/icon-error.svg?inline'
      )
    ),
    'icon-gr-block': defineAsyncComponent(() =>
      import(
        /* webpackChunkName: "icons" */
        /* webpackMode: "lazy" */
        /* webpackPreload: true */
        '@/assets/img/icons/icon-gr-block.svg?inline'
      )
    ),
    'icon-gr-check': defineAsyncComponent(() =>
      import(
        /* webpackChunkName: "icons" */
        /* webpackMode: "lazy" */
        /* webpackPreload: true */
        '@/assets/img/icons/icon-gr-check.svg?inline'
      )
    ),
    'icon-gr-farm': defineAsyncComponent(() =>
      import(
        /* webpackChunkName: "icons" */
        /* webpackMode: "lazy" */
        /* webpackPreload: true */
        '@/assets/img/icons/icon-gr-farm.svg?inline'
      )
    ),
    'icon-gr-list': defineAsyncComponent(() =>
      import(
        /* webpackChunkName: "icons" */
        /* webpackMode: "lazy" */
        /* webpackPreload: true */
        '@/assets/img/icons/icon-gr-list.svg?inline'
      )
    ),
    'icon-gr-search': defineAsyncComponent(() =>
      import(
        /* webpackChunkName: "icons" */
        /* webpackMode: "lazy" */
        /* webpackPreload: true */
        '@/assets/img/icons/icon-gr-search.svg?inline'
      )
    ),
    'icon-gr-team': defineAsyncComponent(() =>
      import(
        /* webpackChunkName: "icons" */
        /* webpackMode: "lazy" */
        /* webpackPreload: true */
        '@/assets/img/icons/icon-gr-team.svg?inline'
      )
    ),
    'icon-gr-wallet': defineAsyncComponent(() =>
      import(
        /* webpackChunkName: "icons" */
        /* webpackMode: "lazy" */
        /* webpackPreload: true */
        '@/assets/img/icons/icon-gr-wallet.svg?inline'
      )
    ),
    'icon-minus': defineAsyncComponent(() =>
      import(
        /* webpackChunkName: "icons" */
        /* webpackMode: "lazy" */
        /* webpackPreload: true */
        '@/assets/img/icons/icon-minus.svg?inline'
      )
    ),
    'icon-plus': defineAsyncComponent(() =>
      import(
        /* webpackChunkName: "icons" */
        /* webpackMode: "lazy" */
        /* webpackPreload: true */
        '@/assets/img/icons/icon-plus.svg?inline'
      )
    ),
    'icon-search': defineAsyncComponent(() =>
      import(
        /* webpackChunkName: "icons" */
        /* webpackMode: "lazy" */
        /* webpackPreload: true */
        '@/assets/img/icons/icon-search.svg?inline'
      )
    ),
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    height: {
      type: String,
      required: false,
      default: '24',
    },
    width: {
      type: String,
      required: false,
      default: '24',
    },
  },
}
</script>

<style lang="scss">
.plc-svgIcon {
  display: flex;
}
</style>
